module.exports = __webpack_public_path__ + "static/media/add event info.f4083db2.svg";